import {cs}             from "@Common/react/chain-services";
import {KeyedState}     from "@Common/react/keyed-state";
import {Load}           from "@Common/react/load";
import {RangeLoader}    from "@Common/react/range-loader";
import {flatten1, last} from "@Common/utils/collections";

export const InfiniteLoader = ({step = 10, key, getList, fetchRange, getTotalCount, next}) => cs(
    ["limit", ({}, next) => KeyedState({
        defaultValue: step,
        _key: key,
        next,
    })],
    ["loader", ({limit}, next) => RangeLoader({
        _key: key,
        range: {from: 0, to: limit.value},
        load: fetchRange,
        next,
    })],
    ({loader, limit}) => {

        const lastLoaded = last(loader.list);
        const totalCount = lastLoaded && getTotalCount(lastLoaded);
        const list = flatten1(loader.list.map((loaded) => getList(loaded)));
        return next({
            ...loader,

            totalCount,
            list,
            hasMore: totalCount == null || totalCount > list.length,
            loadMore: () => limit.onChange(limit.value + step),
        });
    },
);